
import Vue from "vue";
import { OpenAPI } from "./commons/client";
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import "./assets/css/style.css";

export default Vue.extend({
  name: "App",

  data: () => ({
    //
  }),

  components: {
    Navbar,
    Footer,
  },

  created() {
    OpenAPI.TOKEN = this.$store.state.token;
  },
});
